import type { SiteResponse } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { useAuth } from '@on3/ui-lib/index';
import { FanSiteItem } from '@public/components/Teams/FanSiteItem';

import styles from './FanSiteList.module.scss';

interface IFanSiteListProps {
  list?: SiteResponse[];
}

// volquest, wolverine, blue and gold, ksr, bamainsider, inside texas, nebraska, warchant
const featuredSites = [373, 80, 363, 24, 72, 73, 370, 372];

export const FanSiteList = ({ list = [] }: IFanSiteListProps) => {
  const { user } = useAuth();
  const defaultFeaturedList: SiteResponse[] | undefined = [];
  const userFeaturedList: SiteResponse[] | undefined = [];
  const userSiteKeys = user?.si;

  featuredSites
    .filter((f) => !userSiteKeys?.includes(f))
    .map((f) => {
      const team = list?.find((t) => t.key === f && !userSiteKeys?.includes(f));

      if (!team) {
        return null;
      }

      return defaultFeaturedList.push(team);
    });

  userSiteKeys?.map((f) => {
    const team = list?.find((t) => t.key === f);

    if (!team) {
      return null;
    }

    return userFeaturedList.push(team);
  });

  const featuredList = [...userFeaturedList, ...defaultFeaturedList];

  return (
    <section className={styles.block}>
      <h3>Fan Sites</h3>

      <ul className={styles.list}>
        {featuredList.map((site: SiteResponse, index) => {
          const isFavoriteTeam = user?.si?.includes(site.key);

          return (
            <FanSiteItem
              data={site}
              isFavoriteTeam={isFavoriteTeam}
              key={site.key}
            />
          );
        })}
      </ul>

      <footer>
        <Link className={styles.viewAll} href={`/teams/`}>
          Fan Sites
        </Link>
      </footer>
    </section>
  );
};
